import { TechnologicalSolutions } from "@/@types";
import { TechnologicalSolutionsResponse } from "../../technologicalSolutions/models/TechnologicalSolutionsResponse";

export function mapTechnologicalSolutions(data: TechnologicalSolutionsResponse): TechnologicalSolutions {

  return data.map((item) => ({
    coverImage: item.cover_image,
    title: item.title,
    slug: item.slug,
    subtitle: item.subtitle,
    description: item.description,
    isBlank: item.is_blank,
    order: item.order,
    statusId: item.status_id,
    url: item.url,
    solutionTypeId: item.solution_type_id,
  }));
}